import { Flex, FlexProps } from '@mantine/core';
import styled, { css } from 'styled-components';

export const CellContent = styled(Flex).attrs(() => ({
	direction: 'column',
	gap: 2,
	w: '100%',
	miw: 0,
}))`
	overflow: hidden;
`;

export const singleLineTextStyle = {
	width: '100%',
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	display: 'block',
};

export const SingleLineText = styled.div`
	display: block;
	width: 100%;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

// Non-negative values reserve the width of the closing ")" so their digits line up with "(1,000)".
export const ParenthesisAlignedValue = styled.span<{ $isNegative: boolean }>`
	${({ $isNegative }) =>
		!$isNegative &&
		css`
			&::after {
				content: ')';
				visibility: hidden;
			}
		`}
`;

export const FooterSummaryCellContainer = styled(Flex).attrs<
	FlexProps & {
		$align?: 'flex-start' | 'center' | 'flex-end';
	}
>(
	({ $align = 'flex-start' }): Partial<FlexProps> => ({
		direction: 'column',
		justify: 'space-between',
		align: $align,
		h: '100%',
		w: '100%',
	})
)``;
